import { TApiError } from 'types/common';

export const readApiError = (error: unknown): Partial<TApiError> => {
  const data = (error as { response?: { data?: Partial<TApiError> } })?.response?.data;
  if (!data || typeof data !== 'object') {
    return {};
  }
  return { errorCode: data.errorCode, errorMessage: data.errorMessage };
};
